import { ReactNode, useContext } from 'react';
import SlidingPane from 'react-sliding-pane';

import { AuthContext } from '../../contexts/AuthContext';
import styled from 'styled-components';

interface SidePaneType {
  isOpen: boolean;
  onRequestClose: () => void;
  children?: ReactNode;
  title?: string;
}

const StyledSlidingPane = styled(SlidingPane)<{ marginTop: string; height: string }>`
  margin-top: ${(props) => props.marginTop};
  height: ${(props) => props.height};
`;

export function SidePane({ isOpen, onRequestClose, children, title }: SidePaneType) {
  const { userPrefs } = useContext(AuthContext);

  const width = window.innerWidth > 768 ? '550px' : '80%';
  const mt = '50px';
  const height = 'calc(100vh - 50px)';

  // Wrap children with a header that includes a back arrow
  const contentWithHeader = (
    <div className="h-100 d-flex flex-column">
      <div className="p-3 border-bottom d-flex align-items-center">
        <button className="btn btn-link p-0 me-2" onClick={onRequestClose} aria-label="Back">
          <i className="fa fa-arrow-left"></i>
        </button>
        {title && <h5 className="mb-0">{title}</h5>}
      </div>
      <div className="flex-grow-1 overflow-auto">{children}</div>
    </div>
  );

  return (
    <>
      {userPrefs?.detailAnimation && (
        <StyledSlidingPane
          hideHeader={true}
          width={width}
          marginTop={mt}
          height={height}
          isOpen={isOpen}
          onRequestClose={onRequestClose}
        >
          {contentWithHeader}
        </StyledSlidingPane>
      )}
      {!userPrefs?.detailAnimation && (
        <StyledSlidingPane
          hideHeader={true}
          width={width}
          marginTop={mt}
          height={height}
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          className="fast-transition"
        >
          {contentWithHeader}
        </StyledSlidingPane>
      )}
    </>
  );
}

export default SidePane;
